module.exports = __webpack_public_path__ + "static/media/camera.7adb9982.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/icons/camera.svg
// module id = 264
// module chunks = 0